export default __webpack_public_path__ + "static/Group 1971-9739dd1fd35ae72eb1045eef14ce05f2.png";